export default __webpack_public_path__ + "static/media/about.191ebe34.jpg";